import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomerInfo } from '../../interfaces/customer-info/customer-info';
import { Email } from '../../interfaces/customer-info/email';
import { Phone } from '../../interfaces/customer-info/phone';
import { Address } from '../../interfaces/customer-info/address';
import { CountryPhoneInfo } from '@core-services/phone/models/country-phone-info';
import { PhoneTypes } from '../../interfaces/enums/phone-types.enum';
import { EmailsEditFormComponent } from '../emails-edit-form/emails-edit-form.component';
import { PhonesEditFormComponent } from '../phones-edit-form/phones-edit-form.component';
import { AddressesEditFormComponent } from '../addresses-edit-form/addresses-edit-form.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'general-info-form',
    templateUrl: './general-info-form.component.html',
    styleUrls: ['../general-info-base/general-info-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, EmailsEditFormComponent, PhonesEditFormComponent, AddressesEditFormComponent, TranslateModule]
})
export class GeneralInfoFormComponent {
    @Input() public isPrimaryCustomer: boolean;
    @Input() public isSelfProfile: boolean;
    @Input() public emails: Email[];
    @Input() public phones: Phone[];
    @Input() public addresses: Address[];
    @Input() public isFullVersion = true;

    public form = this.formBuilder.group({});
    public readonly emailControlName = 'emails';
    public readonly phoneControlName = 'phones';
    public readonly addressControlName = 'addresses';

    constructor(private readonly formBuilder: FormBuilder) { }

    public cancel(): void {
        this.cancelEdit();
    }

    public save(): CustomerInfo | null {
        if (this.form.invalid) {
            this.form.markAllAsTouched();

            return null;
        }

        const emails = ((this.form.controls[this.emailControlName] as FormArray)?.getRawValue() ?? []) as Email[];
        const addresses = (this.form.controls[this.addressControlName] as FormArray).getRawValue() as Address[];
        const phones = (this.form.controls[this.phoneControlName] as FormArray).getRawValue()
            .map((x: { type: PhoneTypes, id: number, number: { phoneNumber: string, countryCode: CountryPhoneInfo }, isAlertReceiver: boolean }) => {
                return ({ id: x.id, number: { countryCode: x.number.countryCode.codeName, phoneNumber: x.number.phoneNumber, }, isAlertReceiver: x.isAlertReceiver, type: x.type });
            }) as Phone[];

        this.cancelEdit();

        return new CustomerInfo(phones, emails, addresses);
    }

    private cancelEdit(): void {
        this.form.removeControl(this.addressControlName);
        this.form.removeControl(this.emailControlName);
        this.form.removeControl(this.phoneControlName);
    }
}